"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.swapSelectableElementForCopyableText = exports.selectableTextElement = exports.addSelectableNode = void 0;
function addSelectableNode(dom) {
    const wrapper = document.createElement("span");
    wrapper.className = "mathjax-wrapper";
    // We don't want the user to be able to select the rendered math, since
    // it does not copy-paste correctly.
    wrapper.appendChild(makeMathUnselectable(dom));
    // Append a hidden element containing the TeX as its text content, so the
    // user can copy-paste the TeX.
    wrapper.appendChild(makeHiddenButCopyableNode());
    return wrapper;
}
exports.addSelectableNode = addSelectableNode;
function selectableTextElement(mathjaxElement) {
    return mathjaxElement.querySelector(".mathjax-selectable > svg > text");
}
exports.selectableTextElement = selectableTextElement;
function swapSelectableElementForCopyableText(mathjaxElement, text) {
    const selectableSvgElement = mathjaxElement.querySelector("svg");
    if (selectableSvgElement) {
        const copyableSpan = document.createElement("span");
        copyableSpan.innerText = text;
        copyableSpan.style.opacity = "0";
        swap(selectableSvgElement, copyableSpan);
        // Setting the background color of the whole MathJax element prevents
        // flickering when the selected element is removed from the DOM.
        mathjaxElement.style.backgroundColor = "Highlight";
        setTimeout(() => {
            swap(copyableSpan, selectableSvgElement);
            mathjaxElement.style.backgroundColor = "";
        }, 0);
    }
}
exports.swapSelectableElementForCopyableText = swapSelectableElementForCopyableText;
function makeMathUnselectable(dom) {
    // user-select: none does not work in Chrome, so we have to use the
    // workaround below.
    dom.style.userSelect = "none !important";
    // Explicitly setting `-webkit-user-select: none` works around a bug in
    // Chrome that caused weird placeholder characters to get copied along
    // with the TeX. We have to set it with `setAttribute`, or Chrome
    // automatically converts `-webkit-user-select` to `user-select`. Strangely,
    // `user-select` doesn't fix the problem, but `-webkit-user-select` does.
    // We observed this in Chrome Version 114.0.5735.90.
    const mathElem = dom.querySelector("math");
    mathElem === null || mathElem === void 0 ? void 0 : mathElem.setAttribute("style", "-webkit-user-select: none !important");
    return dom;
}
function makeHiddenButCopyableNode() {
    const fontSizePx = 20;
    const container = document.createElement("span");
    container.className = "mathjax-selectable";
    container.style.fontSize = `${fontSizePx}px`;
    container.setAttribute("aria-hidden", "true");
    // Prevent tap interactions from selecting the copyable node on touchscreen
    // devices. If tapping selects the math, that interferes with the
    // ZoomableTex component in Perseus. See:
    // https://khanacademy.atlassian.net/browse/LC-1385
    container.addEventListener("pointerdown", (event) => {
        if (event.pointerType === "touch") {
            event.preventDefault();
        }
    });
    const textElement = `<text
        y="0"
        dominant-baseline="hanging"
        textlength="100%"
        lengthAdjust="spacingAndGlyphs"
    >&nbsp;</text>`;
    const fudgeFactorToEnsureTextFillsSvg = 0.7;
    const svg = `<svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 5 ${fontSizePx * fudgeFactorToEnsureTextFillsSvg}"
        width="100%"
        height="100%"
        preserveAspectRatio="none"
        fill="transparent"
        stroke="transparent"
    >${textElement}</svg>`;
    // `copyMenuHack` contains a zero-width joiner character, which induces
    // the browser to show the "copy" menu item when the math is right-clicked.
    // Almost any character would work for that purpose—the element just has to
    // contain some text to be copyable (apparently <text> in an SVG doesn't
    // count, though, unless the right-click event that brings up the context
    // menu happens on the <text> itself.
    //
    // The advantage of using a zero-width joiner instead of some other
    // character is that the ZWJ does not actually get copied to the clipboard.
    const copyMenuHack = `<span class="copy-menu-hack">&#8205;</span>`;
    container.innerHTML = `${copyMenuHack}${svg}`;
    return container;
}
function swap(toRemove, toAdd) {
    toRemove.insertAdjacentElement("beforebegin", toAdd);
    toRemove.remove();
}
